import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Smartphone } from "lucide-react";

const QUERY = "(orientation: portrait) and (max-width: 767px)";
const KEY = "rotate-dismissed";

// Phones held upright: ask visitors to turn sideways so the homepage looks exactly like the desktop version
export const RotatePrompt = () => {
  const [portrait, setPortrait] = useState(() => window.matchMedia(QUERY).matches);
  const [skip, setSkip] = useState(() => sessionStorage.getItem(KEY) === "1");
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const on = (e) => setPortrait(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  const show = portrait && !skip;
  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [show]);
  return createPortal(
    <AnimatePresence>
      {show && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[9999] bg-black backdrop-blur-xl flex flex-col items-center justify-center px-8 text-center" data-testid="rotate-prompt">
          <motion.div animate={{ rotate: [0, -90, -90, 0] }} transition={{ duration: 2.4, repeat: Infinity, times: [0, 0.35, 0.75, 1], ease: "easeInOut" }}
            className="w-20 h-20 rounded-2xl border border-sky-400/40 flex items-center justify-center text-sky-300 shadow-[0_0_40px_rgba(14,165,233,0.35)]">
            <Smartphone className="w-10 h-10" />
          </motion.div>
          <h2 className="mt-8 font-['Outfit'] text-3xl text-white">Turn your phone sideways</h2>
          <p className="mt-3 text-gray-400 text-sm max-w-xs">Reflections looks best in landscape — the full showroom experience, just like on a computer.</p>
          <button onClick={() => { sessionStorage.setItem(KEY, "1"); setSkip(true); }} className="mt-10 text-xs text-gray-500 underline underline-offset-4 hover:text-gray-300" data-testid="rotate-prompt-continue">
            Continue in portrait
          </button>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );
};
